import { createUseStyles } from "react-jss";
import { ITheme } from "../../../store/slices/theme";

export const useStyles = createUseStyles((theme: ITheme) => ({
  root: {
    minHeight: "100dvh",
    backgroundColor: theme.colors.Background8,
    overflow: "scroll !important",
    "-ms-overflow-style": "none" /* IE and Edge */,
    scrollbarWidth: "none" /* Firefox */,
    /* Hide scrollbar for Chrome, Safari and Opera */
    "&::-webkit-scrollbar": {
      display: "none",
    },
  },

  content: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing.space12,
    padding: "70px 16px",
  },

  itemWrapper: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing.space16,
    padding: "24px 16px",
    backgroundColor: theme.colors.Background2,
    borderRadius: theme.radius.large,
  },

  voucherIconWrapper: {
    width: 60,
    height: 60,
    borderRadius: theme.radius.small,
  },

  infoWrapper: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing.space4,
    flex: 1,
    justifyContent: "center",
  },

  price: {
    color: "#00c853 !important",
  },

  description: {
    overflow: "hidden",
    textOverflow: "ellipsis",
    display: "-webkit-box",
    WebkitLineClamp: 9,
    WebkitBoxOrient: "vertical",
  },
}));
